import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const items = [{
  id: 1,
  emoji: '✏️',
  title: 'Resumen CASO 1',
  content: <>
        <p className="text-gray-200 text-sm leading-relaxed mb-3" data-id="element-20">
          <span className="font-bold text-white" data-id="element-21">
            🔵 El secreto detrás de la puerta cerrada:
          </span>{' '}
          Una joven fue hallada sin vida en su propio hogar.
        </p>
        <p className="text-gray-300 text-sm leading-relaxed mb-3" data-id="element-22">
          Las pruebas apuntan a personas cercanas, pero nadie dice toda la
          verdad.
        </p>
        <p className="text-gray-300 text-sm leading-relaxed mb-3" data-id="element-23">
          Cada detalle oculta una mentira… y solo vos podés descubrirla.
        </p>
        <p className="text-white font-bold text-sm" data-id="element-24">
          🔍 ¿Podrás encontrar al asesino?
        </p>
      </>
}, {
  id: 2,
  emoji: '🚨',
  title: 'Resumen CASO 2',
  content: <>
        <p className="text-gray-200 text-sm leading-relaxed mb-3" data-id="element-25">
          <span className="font-bold text-white" data-id="element-26">
            🌻 El asesino que deja flores:
          </span>{' '}
          Un cuerpo aparece flotando en un lago, con un girasol grabado en su
          piel y una nota firmada por "R.L.".
        </p>
        <p className="text-gray-300 text-sm leading-relaxed mb-3" data-id="element-27">
          Cada año, la misma fecha. La misma flor. La misma historia.
        </p>
        <p className="text-white font-bold text-sm" data-id="element-28">
          🕯 ¿Podrás detener al asesino antes del próximo 17 de noviembre?
        </p>
      </>
}, {
  id: 3,
  emoji: '🕵️',
  title: 'Resumen CASO 3',
  content: <>
        <p className="text-gray-200 text-sm leading-relaxed mb-3" data-id="element-29">
          <span className="font-bold text-white" data-id="element-30">
            🩸 La verdad escrita en el espejo:
          </span>{' '}
          Un empresario es encontrado muerto en su oficina.
        </p>
        <p className="text-gray-300 text-sm leading-relaxed mb-3" data-id="element-31">
          Las cámaras fueron alteradas y el mensaje que dejó cambia todo lo que
          se creía saber.
        </p>
        <p className="text-white font-bold text-sm" data-id="element-32">
          🗃 Nada es casualidad. Alguien planeó cada detalle.
        </p>
      </>
}, {
  id: 4,
  emoji: '🕵️',
  title: 'Resumen CASO 4',
  content: <>
        <p className="text-gray-200 text-sm leading-relaxed mb-3" data-id="element-33">
          <span className="font-bold text-white" data-id="element-34">El Apagón de Astro IV:</span>{' '}
          Durante la primera misión de una estación espacial privada, un apagón
          total deja a la tripulación incomunicada. Minutos después, la
          brillante directora del proyecto aparece muerta en el laboratorio.
        </p>
        <p className="text-gray-300 text-sm leading-relaxed mb-3" data-id="element-35">
          Todo apunta a una falla técnica… hasta que las pruebas revelan
          sabotaje.
        </p>
        <p className="text-gray-300 text-sm leading-relaxed mb-3" data-id="element-36">
          Entre secretos, traiciones y ambiciones multimillonarias, nada es lo
          que parece.
        </p>
        <p className="text-gray-300 text-sm leading-relaxed" data-id="element-37">
          ¿Podrás descubrir quién apagó las luces… y quién apagó su vida?
        </p>
      </>
}, {
  id: 5,
  emoji: '🎲',
  title: '¿Cómo Jugar?',
  content: <>
        <p className="text-gray-300 text-sm leading-relaxed mb-3" data-id="element-38">
          El juego está diseñado para jugarse{' '}
          <span className="font-bold text-white" data-id="element-39">desde 1 hasta 5 personas</span>
          . Así que puedes jugar con tu pareja, amigos o familia.
        </p>
        <p className="text-gray-300 text-sm leading-relaxed mb-3" data-id="element-40">
          Después de tu compra te llegará un mail con los casos.
        </p>
        <p className="text-gray-300 text-sm leading-relaxed" data-id="element-41">
          Imprime el juego y sigue las instrucciones dentro de cada caso.
        </p>
      </>
}];
export function CasesAccordion() {
  const [openId, setOpenId] = useState<number | null>(null);
  const toggle = (id: number) => setOpenId(openId === id ? null : id);
  return <section className="py-5 px-4" style={{
    backgroundColor: '#0d0d0d'
  }} data-id="element-42">
      <div className="max-w-xl mx-auto" data-id="element-43">
        <div className="flex flex-col" data-id="element-44">
          {items.map((item, idx) => {
          const isOpen = openId === item.id;
          return <div key={item.id} style={{
            borderTop: idx === 0 ? '1px solid #2a2a2a' : 'none',
            borderBottom: '1px solid #2a2a2a',
            backgroundColor: isOpen ? '#1a1a1a' : 'transparent',
            transition: 'background-color 0.2s'
          }} data-id="element-45">
                <button className="w-full flex items-center justify-between px-4 py-4 text-left" onClick={() => toggle(item.id)} data-id="element-46">
                  <span className="text-white font-semibold text-sm sm:text-base flex items-center gap-2" style={isOpen ? {
                textDecoration: 'underline',
                textDecorationColor: '#c0392b',
                textUnderlineOffset: '4px'
              } : {}} data-id="element-47">
                    <span data-id="element-48">{item.emoji}</span>
                    {item.title}
                  </span>
                  {isOpen ? <ChevronUp size={18} className="text-gray-400 flex-shrink-0" data-id="element-49" /> : <ChevronDown size={18} className="text-gray-400 flex-shrink-0" data-id="element-50" />}
                </button>
                {isOpen && <div className="px-4 pb-5" data-id="element-51">{item.content}</div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}